import site from './profile/en/site';
import footer from './profile/en/footer';
import home from './profile/en/home';
import about from './profile/en/about';
import projectsPage from './profile/en/projectsPage';
import projects from './profile/en/projects';
import expertise from './profile/en/expertise';
import contact from './profile/en/contact';

const profileContentEn = {
  site,
  footer,
  home,
  about,
  projectsPage,
  projects,
  expertise,
  contact,
};

export default profileContentEn;
